const HOMEPAGE = "home";

//Profile
const PROFILE_HOMEPAGE = "Profile Dashboard";
const PROFILE_USER = "Profile User";
const PROFILE_LOGIN = "Profile Login";
const PROFILE_BILLING = "Profile Billing";
const PROFILE_NEWSLETTERS = "Profile Newsletters";
const PROFILE_SERVER_MANAGEMENT = "Server Management";

//Auth
const AUTH_LOGIN = "Auth Login";
const AUTH_LOGOUT = "Auth Logout";
const AUTH_REGISTER = "Auth Register";
const AUTH_REGISTER_COMPLETE = "Auth Complete Registration";
const AUTH_PASSWORD_REMINDER = "Auth Password Reminder";
const AUTH_PASSWORD_RESET = "Auth Password Reset";
const AUTH_ACTIVATION = "Auth Activate Account";
const AUTH_ACTIVATION_EMAIL = "Auth Activation E-mail";
const AUTH_TRANSFER_ACCOUNT = "Auth Transfer Account";
const AUTH_TWO_FACTOR_RESET = "Auth Two Factor Reset";
const AUTH_LOCKED = "Auth Account Locked";

//Auth Embed
const AUTH_EMBED_LOGIN = "Auth Embed Login";
const AUTH_EMBED_REGISTER = "Auth Embed Register";
const AUTH_EMBED_REGISTER_COMPLETE = "Auth Embed Complete Registration";
const AUTH_EMBED_PASSWORD_REMINDER = "Auth Embed Password Reminder";
const AUTH_EMBED_LOCKED = "Auth Embed Account Locked";

//Misc
const TERMS_AND_CONDITION = "Terms & Conditions";
const UNSUBSCRIBE = "Unsubscribe";

export {
  HOMEPAGE,
  PROFILE_HOMEPAGE,
  PROFILE_USER,
  PROFILE_LOGIN,
  PROFILE_BILLING,
  PROFILE_NEWSLETTERS,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REGISTER,
  AUTH_REGISTER_COMPLETE,
  AUTH_PASSWORD_REMINDER,
  AUTH_PASSWORD_RESET,
  AUTH_ACTIVATION,
  AUTH_ACTIVATION_EMAIL,
  AUTH_TRANSFER_ACCOUNT,
  AUTH_TWO_FACTOR_RESET,
  AUTH_LOCKED,
  AUTH_EMBED_LOCKED,
  AUTH_EMBED_LOGIN,
  AUTH_EMBED_PASSWORD_REMINDER,
  AUTH_EMBED_REGISTER,
  AUTH_EMBED_REGISTER_COMPLETE,
  TERMS_AND_CONDITION,
  UNSUBSCRIBE,
  PROFILE_SERVER_MANAGEMENT
};
